import stateConfig from './config'
import Vue from 'vue'
import Vuex from 'vuex'
import api from '@/api'
import VueLocalStorage from 'vue-localstorage'
import { Validator } from 'vee-validate'

Vue.use(Vuex)
Vue.use(VueLocalStorage)

export default {
  ['UPDATE_FB_INFO'](state, payload) {
    state.facebook_info = payload
    Vue.localStorage.set('facebook_info', JSON.stringify(state.facebook_info))
  },
  ['UPDATE_LINE_INFO'](state, payload) {
    state.line_info = payload
    Vue.localStorage.set('line_info', JSON.stringify(state.line_info))
  },
  [stateConfig.LOGIN]: function(state) {
    state.loading = true
  },
  [stateConfig.LOGIN_SUCCESS]: function(state) {
    state.isLoggedIn = true
    state.loading = false
  },
  [stateConfig.LOGIN_FAIL]: function(state) {
    state.loading = false
  },
  [stateConfig.LOGOUT]: function(state) {
    state.isLoggedIn = false
    state.loading = false
  },
  [stateConfig.SELECT_BOT]: function(state) {
    state.isSelectedBot = true
  },
  [stateConfig.LOADING]: function(state) {
    state.loading = !state.loading
  },
  [stateConfig.CLEAR_LOADING]: function(state) {
    state.loading = false
  },
  [stateConfig.SIDEBAR]: function(state) {
    state.openSidebar = !state.openSidebar
  },
  [stateConfig.SELECT_NEW_BOT]: function(state, bot) {
    state.selectedBot = bot
  },
  [stateConfig.UPDATE_SETTING]: function(state, setting) {
    state.setting = setting
  },
  [stateConfig.UPDATE_WELCOME_MESSAGE]: function(state, welcomeMessage) {
    state.welcomeMessage = welcomeMessage
  },
  [stateConfig.UPDATE_WELCOME_MESSAGE2]: function(state, welcomeMessage) {
    state.welcomeMessage2 = welcomeMessage
  },
  [stateConfig.UPDATE_MODAL_WELCOME]: function(state, value) {
    if (value) {
      state.showModalWelcome = true
      Vue.localStorage.set('showModalWelcome', true)
    } else {
      state.showModalWelcome = undefined
      Vue.localStorage.remove('showModalWelcome')
    }
  },
  [stateConfig.SET_LANG](state, payload) {
    // if (state.userid && payload && state.tutoriallist) {
    //   var data = {
    //     lang: payload ? payload : 'en',
    //     tutoriallist: state.tutoriallist
    //   }
    //   api.updateTutoriallist(data, function(error, response) {
    //     if (error) {
    //       console.error(error)
    //     }
    //   })
    // }
    Vue.i18n.set(payload)
    Validator.localize(payload)
  },
  [stateConfig.UPDATE_ALERT](state, payload) {
    if (state.alert) {
      var alertIndex = state.alert.findIndex(function(alert) {
        return alert.name === payload.name
      })
      if (alertIndex > 0) {
        state.alert[alertIndex] = payload
      } else {
        state.alert.push(payload)
      }
    } else {
      state.alert.push(payload)
    }
    Vue.localStorage.set('alerts', JSON.stringify(state.alert))
  },
  [stateConfig.SET_LIVECHAT_USERS](state, payload) {
    state.livechat.userlist[payload.type].users = payload.users
  },
  [stateConfig.SET_KETSHOP_TOKEN](state, payload) {
    if (payload.useketshop !== 'undefined') state.selectedBot.useketshop = payload.useketshop
    if (payload.ketshop_api_key) state.selectedBot.ketshop_api_key = payload.ketshop_api_key
    if (payload.ketshop_api_secret)
      state.selectedBot.ketshop_api_secret = payload.ketshop_api_secret

    Vue.localStorage.set('selectedBot', JSON.stringify(state.selectedBot))
  },
  // $store.commit('modalAssign', {open: true, component: () => import('@/Mootest.vue') })
  modalAssign(state, data) {
    let input = JSON.parse(JSON.stringify(data.input))
    Object.assign(state.modal, { ...data, input })
  },
  allSchoolsAssign(state, data) {
    Object.assign(state.allSchools, data)
  },
  [stateConfig.SET_LIVECHAT_USER](state, payload) {
    state.livechat.currentUser = payload
  },
  ['SET_LIVECHAT_USER_ATTR'](state, payload) {
    state.livechat.currentUser[payload.name] = payload.value
  },
  ['SELECT_PAGE_LIVECHAT'](state, { pageID, lineModularBotID }) {
    state.livechat.pageid = pageID
    state.livechat.line_modular_botid = lineModularBotID
    state.livechat.userlist = {
      admin: {
        offset: 0,
        loading: false,
        limit: 20,
        users: [],
        isAutoRefresh: true,
        hasMore: true,
        hasNew: false
      },
      bot: {
        offset: 0,
        loading: false,
        limit: 20,
        users: [],
        isAutoRefresh: true,
        hasMore: true,
        hasNew: false
      }
    }
  },
  ['UPDATE_ASTON_ADMIN'](state, payload) {
    state.astonAdmins = payload
  },
  ['SET_LIVECHAT_FILTER'](state, payload) {
    state.livechat.filter = payload
  },
  ['SET_LIVECHAT_TYPE'](state, payload) {
    state.livechat.type = payload
  },
  ['SET_LIVECHAT_LINE_TAB'](state, payload) {
    state.livechat.line_tab = payload
  },
  ['SET_LIVECHAT_APP'](state, payload) {
    state.livechat.app = payload
  },
  ['SET_LIVECHAT_USER'](state, payload) {
    state.livechat.currentUser = payload
  },
  ['SET_BOTLIST'](state, payload) {
    state.botlist = payload
  },
  ['SET_DELAY_IMPORT'](state, payload) {
    if (state.delayImportUserTime.length == 0) {
      state.delayImportUserTime.push(payload)
    } else {
      var index = state.delayImportUserTime.findIndex(el => {
        return el.pageid == payload.pageid
      })
      if (index != -1) {
        Vue.set(state.delayImportUserTime, index, payload)
      } else {
        state.delayImportUserTime.push(payload)
      }
    }
    Vue.localStorage.set('delayImportUserTime', JSON.stringify(state.delayImportUserTime))
  },
  ['REMOVE_DELAY_IMPORT'](state, payload) {
    if (state.delayImportUserTime.length == 0) {
    } else {
      var index = state.delayImportUserTime.findIndex(el => {
        return el.pageid == payload.pageid
      })
      if (index != -1) {
        state.delayImportUserTime.splice(index, 1)
      }
    }
    Vue.localStorage.set('delayImportUserTime', JSON.stringify(state.delayImportUserTime))
  },
  ['SET_LIVECHAT_LOADMORE'](state, payload) {
    state.livechat.loadmore = payload
  },
  ['SET_INTENTS'](state, { intents, loadingIntents }) {
    if (intents !== undefined) {
      state.intents = intents.map(function(val) {
        var intent = { ...val }
        intent.isShow = false

        intent.ableToDelete = ![
          '{welcome}',
          '{default}',
          '{default_comment_to_inbox}',
          '{default_live}'
        ].includes(intent.intentname)
        return intent
      })
    } else {
      state.intents = []
    }
    state.loadingIntents = loadingIntents
  },
  ['SET_INTENT'](state, payload) {
    if (!state.intents) {
      state.intents = []
    }
    if (payload.id) {
      var index = state.intents.findIndex(el => {
        return el.id == payload.id
      })
      if (index != -1) {
        Vue.set(state.intents, index, payload)
      } else {
        state.intents.push(payload)
      }
    } else {
      state.intents.push(payload)
    }
  },
  ['DELETE_INTENT'](state, id) {
    var index = state.intents.findIndex(el => {
      return el.id == id
    })
    if (index != -1) {
      state.intents.splice(index, 1)
    }
  },
  ['SET_LINENOTIFY_LIST'](state, payload) {
    state.linenotifylist = payload
  },
  ['SET_REPORT_INBOXMESSAGE'](state, payload) {
    state.reportInboxMessage = payload
  },
  ['SET_REPORT_REPLYTOCOMMENT'](state, payload) {
    state.reportReplyToComment = payload
  },
  ['SET_REPORT_REPLYTOINBOX'](state, payload) {
    state.reportReplyToInbox = payload
  },
  ['SET_REPORT_HIDETOCOMMENT'](state, payload) {
    state.reportHideToComment = payload
  },
  ['SET_SHOW_WELCOME_MODAL'](state, payload) {
    state.showWelcomeModal = payload
  },
  ['SET_SHOW_TEST_CHAT'](state, payload) {
    state.test_bot.showChat = payload
  },
  ['ADD_MESSAGE_TEST'](state, payload) {
    state.test_bot.messages.push(payload)
  },
  ['SET_MESSAGE_TEST'](state, payload) {
    state.test_bot.messages = payload
  },
  ['SET_CONTEXT_OUT'](state, payload) {
    state.test_bot.contextOut = payload
  },
  ['SET_CHANNEL'](state, payload) {
    state.test_bot.channel = payload
  },
  ['SET_LOADING_WELCOME'](state, payload) {
    state.loadingWelcome = payload
  },
  ['CLEAR_LIVECHAT_USERS'](state) {
    for (const key in state.livechat.userlist) {
      if (Object.hasOwnProperty.call(state.livechat.userlist, key)) {
        Vue.set(state.livechat.userlist[key], 'users', [])
      }
    }
  },
  ['SET_LIVECHAT_USER_DETAIL'](state, payload) {
    state.livechat.user = payload
  },
  ['SET_LIVECHAT_SHOW_SELECT_USER'](state, payload) {
    state.livechat.show_select_user = payload
  },
  ['SET_MEMBERGROUP'](state, payload) {
    state.livechat.memberGroup = payload
  },

  ['ADD_EDITTING_INTENT'](state, payload) {
    let intent = state.edittingIntent.find(el => {
      return el == payload
    })

    if (!intent) state.edittingIntent.push(payload)
  },
  ['REMOVE_EDITTING_INTENT'](state, payload) {
    let index = state.edittingIntent.findIndex(el => {
      return el == payload
    })

    if (index != -1) state.edittingIntent.splice(index, 1)
  },
  ['CLEAR_EDITTING_INTENT'](state) {
    state.edittingIntent = []
  },
  ['SET_SHIPPING_COST_DISTANCE'](state, { gmapapikey, distances, loadingdistances }) {
    state.gmapapikey = gmapapikey !== undefined ? gmapapikey : ''
    if (distances !== undefined) {
      state.distances = distances
    } else {
      state.distances = []
    }
    state.loadingdistances = loadingdistances
  },
  ['SET_ACTIVE_PAGE'](state, payload) {
    state.isActivePage = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js